<!-- Content Area -->
<div class="p-8">
    <div class="flex justify-between items-center mb-6">
        <h1 class="text-3xl font-bold text-gray-900">Tenant List</h1>
        <button
            (click)="openAddModal()"
            class="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 text-base lg:text-sm font-semibold rounded-lg transition flex items-center gap-2"
        >
            <span>+</span>
            <span>Add Tenant</span>
        </button>
    </div>

    <!-- Table -->
    <div class="bg-white rounded-lg shadow-sm mb-6">
        <div class="overflow-x-auto">
            <table class="w-full">
                <thead>
                    <tr class="border-b border-gray-200">
                        <th
                            class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                        >
                            No
                        </th>
                        <th
                            class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                        >
                            Name
                        </th>
                        <th
                            class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                        >
                            Code
                        </th>
                        <th
                            class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                        >
                            Domain
                        </th>
                        <th
                            class="text-center py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                        >
                            Action
                        </th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-gray-100">
                    <tr
                        *ngFor="let tenant of Tenant; let i = index"
                        class="hover:bg-gray-50 transition-colors"
                    >
                        <td class="py-4 px-6 text-sm text-gray-900">
                            {{ i + 1 }}
                        </td>
                        <td class="py-4 px-6 text-sm text-gray-900">
                            {{ tenant.name }}
                        </td>
                        <td class="py-4 px-6 text-sm text-gray-600">
                            {{ tenant.code }}
                        </td>
                        <td class="py-4 px-6 text-sm text-gray-600">
                            <div *ngFor="let domain of tenant.domains" class="flex items-center gap-2 mb-1">
                                <span>{{ domain.domain }}</span>
                                <button
                                    (click)="unsetDomain(tenant.id, domain.id, domain.domain)"
                                    class="text-red-500 hover:text-red-700 transition-colors"
                                    title="Hapus domain"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                            <div *ngIf="!tenant.domains || tenant.domains.length === 0" class="text-gray-400 italic">
                                Belum ada domain
                            </div>
                        </td>
                        <td class="py-4 px-6">
                            <div class="flex items-center justify-center gap-0">
                                <button
                                    (click)="openEditModal(tenant.id)"
                                    class="text-gray-600 hover:text-gray-900 transition-colors border border-[#D5D5D5] py-2 px-4 rounded-l-lg hover:bg-gray-50"
                                >
                                    <img
                                        src="assets/visidea/icon/pencil-write.png"
                                        class="w-[16px] h-[16px]"
                                        alt="Edit"
                                    />
                                </button>
                                <button
                                    (click)="openDomainModal(tenant.id)"
                                    class="text-gray-600 hover:text-gray-900 transition-colors border border-[#D5D5D5] py-2 px-4 hover:bg-gray-50"
                                >
                                    <img
                                        src="assets/visidea/icon/domain.png"
                                        class="w-[16px] h-[16px]"
                                        alt="Edit"
                                    />
                                </button>
                                <button
                                    (click)="
                                        deleteTenant(tenant.id, tenant.name)
                                    "
                                    class="text-red-500 hover:text-red-700 transition-colors border border-[#D5D5D5] py-2 px-4 rounded-r-lg hover:bg-red-50"
                                >
                                    <img
                                        src="assets/visidea/icon/bin.png"
                                        class="w-[16px] h-[16px]"
                                        alt="Delete"
                                    />
                                </button>
                            </div>
                        </td>
                    </tr>

                    <!-- Empty State -->
                    <tr *ngIf="Tenant.length === 0">
                        <td colspan="4" class="py-8 text-center text-gray-500">
                            Tidak ada data tenant
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Pagination -->
        <div
            class="flex items-center justify-between px-6 py-4 border-t border-gray-200"
        >
            <button
                class="flex items-center gap-2 px-4 py-2 text-sm text-gray-600 hover:bg-gray-50 rounded-lg"
            >
                <img
                    src="assets/visidea/icon/left.png"
                    class="w-[12px] h-[12px]"
                    alt=""
                />
                <span>Previous</span>
            </button>

            <button
                class="flex items-center gap-2 px-4 py-2 text-sm text-gray-600 hover:bg-gray-50 rounded-lg"
            >
                <span>Next</span>
                <img
                    src="assets/visidea/icon/right.png"
                    class="w-[12px] h-[12px]"
                    alt=""
                />
            </button>
        </div>
    </div>
</div>

<!-- Modal Add/Edit Tenant -->
<div
    *ngIf="isModalOpen"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
>
    <div
        class="bg-white rounded-lg shadow-xl max-w-md w-full p-6 animate-fadeIn"
        (click)="$event.stopPropagation()"
    >
        <div class="flex justify-between items-center mb-6">
            <h2 class="text-2xl font-bold text-gray-900">
                {{ isEditMode ? "Edit Tenant" : "Add New Tenant" }}
            </h2>
            <button
                (click)="closeModal()"
                class="text-gray-400 hover:text-gray-600 text-2xl"
            >
                &times;
            </button>
        </div>

        <form (ngSubmit)="onSubmit()" #tenantFormElement="ngForm">
            <!-- Name -->
            <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Name <span class="text-red-500">*</span>
                </label>
                <input
                    type="text"
                    [(ngModel)]="tenantForm.name"
                    name="name"
                    required
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter tenant name (e.g., Dusun Bambu)"
                />
            </div>

            <!-- Code -->
            <div class="mb-6">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Code <span class="text-red-500">*</span>
                </label>
                <input
                    type="text"
                    [(ngModel)]="tenantForm.code"
                    name="code"
                    required
                    maxlength="20"
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 uppercase"
                    placeholder="Enter tenant code (e.g., DUSBAM)"
                    style="text-transform: uppercase"
                />
                <p class="mt-1 text-xs text-gray-500">
                    Hanya huruf besar dan angka, tanpa spasi
                </p>
            </div>

            <!-- Buttons -->
            <div class="flex gap-3">
                <button
                    type="button"
                    (click)="closeModal()"
                    [disabled]="isSubmitting"
                    class="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition disabled:opacity-50"
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    [disabled]="isSubmitting"
                    class="flex-1 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    <span *ngIf="!isSubmitting">
                        {{ isEditMode ? "Update" : "Create" }}
                    </span>
                    <span *ngIf="isSubmitting"> Processing... </span>
                </button>
            </div>
        </form>
    </div>
</div>

<div
    *ngIf="isDomainModalOpen"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
    (click)="closeDomainModal()"
>
    <div
        class="bg-white rounded-lg shadow-xl max-w-md w-full p-6 animate-fadeIn"
        (click)="$event.stopPropagation()"
    >
        <div class="flex justify-between items-center mb-6">
            <h2 class="text-2xl font-bold text-gray-900">
                Set Domain
            </h2>
            <button
                (click)="closeDomainModal()"
                class="text-gray-400 hover:text-gray-600 text-2xl"
            >
                &times;
            </button>
        </div>

        <form (ngSubmit)="setDomain()" #domainFormElement="ngForm">
            <!-- Name -->
            <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Domain <span class="text-red-500">*</span>
                </label>
                <input
                    type="text"
                    [(ngModel)]="domainForm.domain"
                    name="domain"
                    required
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="visidea.com"
                />
            </div>

            <!-- Buttons -->
            <div class="flex gap-3">
                <button
                    type="button"
                    (click)="closeDomainModal()"
                    [disabled]="isSubmitting"
                    class="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition disabled:opacity-50"
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    [disabled]="isSubmitting"
                    class="flex-1 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    <span *ngIf="!isSubmitting">
                        Submit
                    </span>
                    <span *ngIf="isSubmitting"> Processing... </span>
                </button>
            </div>
        </form>
    </div>
</div>
